import {
  IonContent,
  IonIcon,
  IonButton,
} from "@ionic/react";
import {
  settingsOutline,
  personOutline,
  notificationsOutline,
  lockClosedOutline,
  colorPaletteOutline,
  moonOutline,
  sunnyOutline,
  languageOutline,
  shieldOutline,
  informationCircleOutline,
  saveOutline,
  refreshOutline,
  trashOutline,
  eyeOutline,
  eyeOffOutline,
  volumeHighOutline,
  volumeOffOutline,
  phonePortraitOutline,
  mailOutline,
} from "ionicons/icons";
import { useEffect, useState } from "react";
import { Card, Typography, Chip, Switch, Slider } from "@mui/joy";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import { useConfiguraciones } from "./useConfiguraciones";
import "./Configuraciones.css";

function Configuraciones() {
  const {
    usuario,
    configuraciones,
    cargando,
    toast,
    setToast,
    actualizarConfiguracion,
    resetearConfiguraciones,
    guardarConfiguraciones,
  } = useConfiguraciones((abrir, mensaje, tipo) => setToast({ open: abrir, mensaje, tipo }));

  const [expandedSections, setExpandedSections] = useState({
    perfil: true,
    notificaciones: false,
    privacidad: false,
    apariencia: false,
    avanzado: false,
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <div className="configuraciones-tech-container">
      {/* Header Tech */}
      <div className="tech-config-header">
        <div className="tech-title-section">
          <div className="tech-title-content">
            <IonIcon icon={settingsOutline} className="tech-title-icon" />
            <div>
              <h1 className="tech-page-title">Configuraciones</h1>
              <p className="tech-subtitle">Personaliza tu experiencia médica</p>
            </div>
          </div>
        </div>

        <div className="tech-header-actions">
          <button
            className="tech-action-btn secondary"
            onClick={resetearConfiguraciones}
            disabled={cargando}
          >
            <IonIcon icon={refreshOutline} />
            <span>Restaurar</span>
          </button>
          <button
            className="tech-action-btn primary"
            onClick={guardarConfiguraciones}
            disabled={cargando}
          >
            <IonIcon icon={saveOutline} />
            <span>Guardar Cambios</span>
          </button>
        </div>
      </div>

      <div className="configuraciones-content">
        {/* Sección Perfil */}
        <Card className="tech-config-section">
          <div 
            className="tech-section-header"
            onClick={() => toggleSection('perfil')}
          >
            <div className="section-header-info">
              <IonIcon icon={personOutline} className="section-icon" />
              <div>
                <h3>Información Personal</h3>
                <p>Gestiona tu perfil y datos personales</p>
              </div>
            </div>
            <IonIcon 
              icon={expandedSections.perfil ? eyeOutline : eyeOffOutline} 
              className="section-toggle" 
            />
          </div>

          {expandedSections.perfil && (
            <div className="tech-section-content">
              <div className="tech-config-item">
                <div className="config-item-info">
                  <h4>Nombre Completo</h4>
                  <p>{usuario?.nombreCompleto || 'No especificado'}</p>
                </div>
                <button className="tech-config-btn">
                  <span>Editar</span>
                </button>
              </div>

              <div className="tech-config-item">
                <div className="config-item-info">
                  <h4>Email</h4>
                  <p>{usuario?.email || 'No especificado'}</p>
                </div>
                <button className="tech-config-btn">
                  <span>Cambiar</span>
                </button>
              </div>

              <div className="tech-config-item">
                <div className="config-item-info">
                  <h4>Teléfono</h4>
                  <p>{usuario?.telefono || 'No especificado'}</p>
                </div>
                <button className="tech-config-btn">
                  <span>Actualizar</span>
                </button>
              </div>
            </div>
          )}
        </Card>

        {/* Sección Notificaciones */}
        <Card className="tech-config-section">
          <div 
            className="tech-section-header"
            onClick={() => toggleSection('notificaciones')}
          >
            <div className="section-header-info">
              <IonIcon icon={notificationsOutline} className="section-icon" />
              <div>
                <h3>Notificaciones</h3>
                <p>Controla cómo y cuándo recibes avisos</p>
              </div>
            </div>
            <IonIcon 
              icon={expandedSections.notificaciones ? eyeOutline : eyeOffOutline} 
              className="section-toggle" 
            />
          </div>

          {expandedSections.notificaciones && (
            <div className="tech-section-content">
              <div className="tech-config-toggle">
                <div className="config-toggle-info">
                  <IonIcon icon={mailOutline} className="config-toggle-icon" />
                  <div>
                    <h4>Notificaciones por Email</h4>
                    <p>Recibe recordatorios de turnos por correo</p>
                  </div>
                </div>
                <Switch
                  checked={configuraciones.notificacionesEmail}
                  onChange={(e) => actualizarConfiguracion('notificacionesEmail', e.target.checked)}
                  className="tech-switch"
                />
              </div>

              <div className="tech-config-toggle">
                <div className="config-toggle-info">
                  <IonIcon icon={phonePortraitOutline} className="config-toggle-icon" />
                  <div>
                    <h4>Notificaciones Push</h4>
                    <p>Alertas instantáneas en tu dispositivo</p>
                  </div>
                </div>
                <Switch
                  checked={configuraciones.notificacionesPush}
                  onChange={(e) => actualizarConfiguracion('notificacionesPush', e.target.checked)}
                  className="tech-switch"
                />
              </div>

              <div className="tech-config-toggle">
                <div className="config-toggle-info">
                  <IonIcon icon={volumeHighOutline} className="config-toggle-icon" />
                  <div>
                    <h4>Sonidos de Notificación</h4>
                    <p>Reproducir sonido al recibir alertas</p>
                  </div>
                </div>
                <Switch
                  checked={configuraciones.sonidosNotificacion}
                  onChange={(e) => actualizarConfiguracion('sonidosNotificacion', e.target.checked)}
                  className="tech-switch"
                />
              </div>
            </div>
          )}
        </Card>

        {/* Sección Privacidad */}
        <Card className="tech-config-section">
          <div 
            className="tech-section-header"
            onClick={() => toggleSection('privacidad')}
          >
            <div className="section-header-info">
              <IonIcon icon={shieldOutline} className="section-icon" />
              <div>
                <h3>Privacidad y Seguridad</h3>
                <p>Protege tu información médica</p>
              </div>
            </div>
            <IonIcon 
              icon={expandedSections.privacidad ? eyeOutline : eyeOffOutline} 
              className="section-toggle" 
            />
          </div>

          {expandedSections.privacidad && (
            <div className="tech-section-content">
              <div className="tech-config-toggle">
                <div className="config-toggle-info">
                  <IonIcon icon={lockClosedOutline} className="config-toggle-icon" />
                  <div>
                    <h4>Autenticación Biométrica</h4>
                    <p>Usar huella digital o Face ID</p>
                  </div>
                </div>
                <Switch
                  checked={configuraciones.autenticacionBiometrica}
                  onChange={(e) => actualizarConfiguracion('autenticacionBiometrica', e.target.checked)}
                  className="tech-switch"
                />
              </div>

              <div className="tech-config-toggle">
                <div className="config-toggle-info">
                  <IonIcon icon={eyeOffOutline} className="config-toggle-icon" />
                  <div>
                    <h4>Modo Privado</h4>
                    <p>Ocultar información sensible en previsualizaciones</p>
                  </div>
                </div>
                <Switch
                  checked={configuraciones.modoPrivado}
                  onChange={(e) => actualizarConfiguracion('modoPrivado', e.target.checked)}
                  className="tech-switch"
                />
              </div>

              <div className="tech-config-item">
                <div className="config-item-info">
                  <h4>Cambiar Contraseña</h4>
                  <p>Actualiza tu contraseña de acceso</p>
                </div>
                <button className="tech-config-btn danger">
                  <span>Cambiar</span>
                </button>
              </div>
            </div>
          )}
        </Card>

        {/* Sección Apariencia */}
        <Card className="tech-config-section">
          <div 
            className="tech-section-header"
            onClick={() => toggleSection('apariencia')}
          >
            <div className="section-header-info">
              <IonIcon icon={colorPaletteOutline} className="section-icon" />
              <div>
                <h3>Apariencia</h3>
                <p>Personaliza el diseño de la aplicación</p>
              </div>
            </div>
            <IonIcon 
              icon={expandedSections.apariencia ? eyeOutline : eyeOffOutline} 
              className="section-toggle" 
            />
          </div>

          {expandedSections.apariencia && (
            <div className="tech-section-content">
              <div className="tech-config-selector">
                <div className="config-selector-info">
                  <IonIcon icon={moonOutline} className="config-selector-icon" />
                  <div>
                    <h4>Tema de la Aplicación</h4>
                    <p>Elige entre claro, oscuro o automático</p>
                  </div>
                </div>
                <div className="tech-theme-options">
                  <button 
                    className={`tech-theme-btn ${configuraciones.tema === 'claro' ? 'active' : ''}`}
                    onClick={() => actualizarConfiguracion('tema', 'claro')}
                  >
                    <IonIcon icon={sunnyOutline} />
                    <span>Claro</span>
                  </button>
                  <button 
                    className={`tech-theme-btn ${configuraciones.tema === 'oscuro' ? 'active' : ''}`}
                    onClick={() => actualizarConfiguracion('tema', 'oscuro')}
                  >
                    <IonIcon icon={moonOutline} />
                    <span>Oscuro</span>
                  </button>
                  <button 
                    className={`tech-theme-btn ${configuraciones.tema === 'auto' ? 'active' : ''}`}
                    onClick={() => actualizarConfiguracion('tema', 'auto')}
                  >
                    <IonIcon icon={phonePortraitOutline} />
                    <span>Auto</span>
                  </button>
                </div>
              </div>

              <div className="tech-config-toggle">
                <div className="config-toggle-info">
                  <IonIcon icon={colorPaletteOutline} className="config-toggle-icon" />
                  <div>
                    <h4>Efectos de Glassmorfismo</h4>
                    <p>Habilitar efectos de cristal y transparencias</p>
                  </div>
                </div>
                <Switch
                  checked={configuraciones.efectosGlass}
                  onChange={(e) => actualizarConfiguracion('efectosGlass', e.target.checked)}
                  className="tech-switch"
                />
              </div>
            </div>
          )}
        </Card>

        {/* Sección Avanzado */}
        <Card className="tech-config-section">
          <div 
            className="tech-section-header"
            onClick={() => toggleSection('avanzado')}
          >
            <div className="section-header-info">
              <IonIcon icon={settingsOutline} className="section-icon" />
              <div>
                <h3>Configuración Avanzada</h3>
                <p>Opciones técnicas y de diagnóstico</p>
              </div>
            </div>
            <IonIcon 
              icon={expandedSections.avanzado ? eyeOutline : eyeOffOutline} 
              className="section-toggle" 
            />
          </div>

          {expandedSections.avanzado && (
            <div className="tech-section-content">
              <div className="tech-config-toggle">
                <div className="config-toggle-info">
                  <IonIcon icon={informationCircleOutline} className="config-toggle-icon" />
                  <div>
                    <h4>Modo Desarrollador</h4>
                    <p>Mostrar información técnica adicional</p>
                  </div>
                </div>
                <Switch
                  checked={configuraciones.modoDesarrollador}
                  onChange={(e) => actualizarConfiguracion('modoDesarrollador', e.target.checked)}
                  className="tech-switch"
                />
              </div>

              <div className="tech-config-item danger-zone">
                <div className="config-item-info">
                  <h4>Eliminar Datos Locales</h4>
                  <p>Borra toda la información almacenada localmente</p>
                </div>
                <button className="tech-config-btn danger">
                  <IonIcon icon={trashOutline} />
                  <span>Eliminar</span>
                </button>
              </div>
            </div>
          )}
        </Card>
      </div>

      <CustomToast
        openToast={toast.open}
        onDidDismiss={(e) => setToast({ open: false, mensaje: "", tipo: "" })}
        message={toast.mensaje}
        colorNotificacion={toast.tipo}
      />
    </div>
  );
}

export default Configuraciones;